import React from 'react';

import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import {
  LeftContainer,
  RightContainer,
  Section,
} from 'components/features/components/marketing-tile-group/styled';
import { ButtonContainer, Wrapper } from 'components/marketing-tile/styles';
import useMediaQuery from 'hooks/use-media-query';

import { Direction, HorizontalPosition, TileSize } from './types';

const SkeletonWrapper = styled(Wrapper)`
  padding: 11px;
  background-color: ${Styles.color.cardBackground};
`;
const Container = styled.div`
  margin-block-start: 0.75rem;
  ${Styles.desktop} {
    margin-block-start: 5rem;
  }
`;
const SkeletonButton = styled(ButtonContainer)`
  & span span {
    border-radius: 99rem;
  }
  margin-block-start: 30px;
`;

const MarketingTileWrapper = ({ size }: { size: TileSize }) => (
  <SkeletonWrapper
    hasBorder={false}
    hasBoxShadow={true}
    lockedAspectRatio={true}
    tileSize={size}
    additionalPadding={`0`}
  >
    <Skeleton height="40px" />
    <Skeleton height="40px" width="80%" />
    <SkeletonButton
      isShowingTwoButtons={false}
      $direction={Direction.DEFAULT}
      buttonPosition={HorizontalPosition.RIGHT}
    >
      <Skeleton height="30px" width="135px" />
    </SkeletonButton>
  </SkeletonWrapper>
);

export const MarketingTileSkeleton = () => {
  const isMobile = useMediaQuery('mobile');
  const size = isMobile ? TileSize.HALF : TileSize.FULL;

  if (isMobile) {
    return (
      <Container>
        <Section>
          <MarketingTileWrapper size={size} />
        </Section>
        <Section>
          <MarketingTileWrapper size={size} />
        </Section>
      </Container>
    );
  }

  return (
    <Container data-testid="marketing-tile-skeleton-loader">
      <Section>
        <LeftContainer>
          <MarketingTileWrapper size={size} />
        </LeftContainer>
        <RightContainer>
          <MarketingTileWrapper size={size} />
        </RightContainer>
      </Section>
    </Container>
  );
};
